import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const usePageTitle = (titleKey, namespace) => {
    const { t } = useTranslation(namespace || 'common');

    useEffect(() => {
        // If namespace is not provided, treat titleKey as a direct string
        if (!namespace) {
            document.title = titleKey;
        } else {
            const title = t(titleKey);
            document.title = `${title}`;
        }
    }, [t, titleKey, namespace]);
};

export default usePageTitle; 